import { REVIEW_RATINGS } from './types';

// Below this many public reviews a listing shows no stars, average or breakdown.
export const MIN_REVIEWS_TO_SHOW_RATING = 3;

/**
 * The listing's rating as server/jobs/reviewStats.js saved it, or null below the minimum.
 *
 * @param {Object} listing API entity: listing
 * @returns {{ count: number, average: number }|null}
 */
export const listingRatingMaybe = listing => {
  const { count, average } = listing?.attributes?.metadata?.reviewStats || {};
  const isShown =
    Number.isInteger(count) && count >= MIN_REVIEWS_TO_SHOW_RATING && Number.isFinite(average);
  return isShown ? { count, average } : null;
};

/**
 * How many reviews gave each star rating, five stars first, or null below the minimum.
 *
 * @param {Array<Object>} reviews API entities: public reviews of one listing
 * @returns {{ count: number, average: number, rows: Array<{ stars: number, count: number }> }|null}
 */
export const ratingBreakdownMaybe = reviews => {
  const ratings = reviews.map(r => r.attributes.rating).filter(r => REVIEW_RATINGS.includes(r));
  if (ratings.length < MIN_REVIEWS_TO_SHOW_RATING) {
    return null;
  }

  return {
    count: ratings.length,
    average: ratings.reduce((sum, r) => sum + r, 0) / ratings.length,
    rows: [...REVIEW_RATINGS].reverse().map(stars => ({
      stars,
      count: ratings.filter(r => r === stars).length,
    })),
  };
};
